<template>
  <div class="my-register-page">
    <div class="my-container">
      <div>
        <b-row>
          <b-col>
            <h1>{{ $t("Inspector") }}</h1>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col sm="12" md="4">
            <custom-input
              @keyup.native.enter="Refresh"
              v-model="filter.certificateNumber"
              :type="'text'"
              :label="$t('certificateNumberLabel')"
              :placeholder="$t('certificateNumberLabel')"
            />
          </b-col>
          <b-col sm="12" md="3">
            <custom-button block @click.native="Refresh">
              <span>
                <b-spinner
                  style="margin-left : 20px"
                  v-if="SearchLoading"
                  small
                ></b-spinner>
                {{ $t("search") }}
              </span>
            </custom-button>
          </b-col>
        </b-row>
        <div
          v-if="!SearchLoading && Searched && LastSearchedCert && (!Inspector || Inspector.length === 0)"
          class="no-right-alert mt-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="#DC2626"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
            />
          </svg>
          <span>{{ $t("noInspectionRight") }}</span>
        </div>

        <b-row class="mt-4">
          <b-col
            sm="12"
            md="6"
            lg="4"
            class="my-2 d-flex"
            v-for="(item, index) in Inspector"
            :key="index"
          >
            <div class="inspector-card">
              <div class="inspector-card__body">
                <p class="inspector-row">
                  <span class="my-text-primary"> {{ $t("fio") }} : </span> 
                  <span>{{ item.fullName }}</span>
                </p>

                <p class="inspector-row">
                  <span class="my-text-primary">
                    {{ $t("parentOrganization") }} :
                  </span>
                   <span>{{ item.parentOrganization }}</span>
                </p>
                <p class="inspector-row">
                  <span class="my-text-primary">
                    {{ $t("Organization") }} :
                  </span>
                   <span>{{ item.organization }}</span>
                </p>
              </div>
              <div class="inspector-card__footer">
                <span class="inspection-right-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="#16A34A"
                    class="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.011-1.05z"
                    />
                  </svg>
                  {{ $t("hasInspectionRight") }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-sidebar v-model="sidebar1" width="400px" shadow no-header right>
      <div class="bg-white h-100 d-flex align-items-center">
        <div>
          <div>
            <span style="font-size: 30px; margin-left: 30px">
              {{ $t("changepassword") }}
            </span>
          </div>
          <div class="mt-4" style="margin-left: 30px;margin-right: 30px">
            <custom-input
              type="password"
              placeholder="******"
              v-model="password.oldpassword"
              :label="$t('oldpassword')"
            ></custom-input>
          </div>
          <div class="mt-2" style="margin-left: 30px;margin-right: 30px">
            <custom-input
              type="password"
              placeholder="******"
              v-model="password.newpassword"
              :label="$t('newpassword')"
            ></custom-input>
          </div>
          <div class="mt-2" style="margin-left: 30px;margin-right: 30px">
            <custom-input
              type="password"
              placeholder="******"
              v-model="password.confirmedpassword"
              :label="$t('confirmedpassword')"
            ></custom-input>
          </div>
          <div class="mt-3" style="margin-left: 30px;margin-right: 30px">
            <custom-button
              variant="success"
              @click.native="changepassword"
              block
            >
              <b-spinner
                v-if="passwordLoading"
                small
                style="margin-right:8px"
              ></b-spinner>
              <div class="mx-4">
                <span> {{ $t("save") }} </span>
              </div>
            </custom-button>
          </div>
        </div>
        <span
          class="close-btn"
          style="position: absolute; top : 0px; right: 0px;cursor:pointer"
          @click="toggle"
        >
          <img src="images/design/fill-close.svg" alt="" />
        </span>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BSpinner,
  BSidebar,
  BFormCheckbox,
  BIconPencil,
  BIconCheck2Square,
  BFormFile,
  BIconPlus,
  BIconX,
} from "bootstrap-vue";
import customInput from "../../components/elements/customInput.vue";
import customTextarea from "../../components/elements/customTextarea.vue";
import customDatePicker from "../../components/elements/customDatePicker.vue";
import customSelect from "../../components/elements/customSelect.vue";
import customButtonOutline from "../../components/elements/customButtonOutline.vue";
import customButton from "../../components/elements/customButton.vue";
import customRadioButton from "../../components/elements/customRadioButton.vue";
import customBadge from "../../components/elements/customBadge.vue";
import customDialog from "../../components/elements/customDiaolg.vue";
import AccountService from "@/services/account.service";
import InspectorService from "@/services/inspector.service";
import customLabel from "../../components/elements/customLabel.vue";
import PlusIcon from "../../components/custom-icons/PlusIcon.vue";
import vSelect from "vue-select";
export default {
  components: {
    BRow,
    BCol,
    BImg,
    customInput,
    customDatePicker,
    customSelect,
    BIconX,
    customButtonOutline,
    BSpinner,
    customButton,
    PlusIcon,
    customRadioButton,
    vSelect,
    customDialog,
    customLabel,
    BSidebar,
    BFormCheckbox,
    BIconPencil,
    BIconCheck2Square,
    BFormFile,
    BIconPlus,
    customBadge,
    customTextarea,
  },
  data() {
    return {
      OblastList: [],
      SearchLoading: false,
      Searched: false,
      LastSearchedCert: "",
      filter: {
        docseries: "",
        docnumber: "",
        dateofbirth: "",
        identitydocumentid: 2,
        kinshipdegreeid: 0,
        ismicroterritory: false,
        certificateNumber: null,
      },
      files: {
        file: [],
        filename: "",
        url: "",
      },
      Inspector: [],
      IdentityDocumentList: [],
      PermanentAdress: {},
      isPermanentAdress: true,
      isActiveAdress: false,
      RefreshEgovLoading: false,
      SaveLoading: false,
      lang: "",
      sidebar1: false,
      passwordLoading: false,
      password: {
        oldpassword: "",
        newpassword: "",
        confirmedpassword: "",
      },
      iseditmode: false,
      admtype: 0,
      FileLoading: false,
      AttachedFiles: [],
      fio: "",
      passport: "",
      person: {},
    };
  },
  created() {
    this.Refresh();

    this.lang = localStorage.getItem("locale") || "uz_cyrl";
  },
  methods: {
    Refresh() {
      this.LastSearchedCert = (this.filter.certificateNumber || "").toString().trim();
      if (this.filter.certificateNumber.length == 0) {
        this.SearchLoading = true;
        InspectorService.Get()
          .then((res) => {
            this.Inspector = res.data;
            this.fio =
              res.data.person.surnameLatin +
              "  " +
              res.data.person.nameLatin +
              "  " +
              res.data.person.patronymLatin;
            this.passport =
              res.data.person.passportSeria +
              " " +
              res.data.person.passportNumber;
            this.person = res.data.person;
            this.SearchLoading = false;
            this.Searched = true;
          })
          .catch((error) => {
            this.SearchLoading = false;
            this.Searched = true;
            this.makeToast(error.response.data.errors, "error");
            this.Inspector = [];
            this.person = {};
            this.fio = "";
            this.passport = "";
          });
      } else {
        this.SearchLoading = true;
        InspectorService.Get(encodeURIComponent(this.filter.certificateNumber))
          .then((res) => {
            this.Inspector = res.data;
            this.fio =
              res.data.person.surnameLatin +
              "  " +
              res.data.person.nameLatin +
              "  " +
              res.data.person.patronymLatin;
            this.passport =
              res.data.person.passportSeria +
              " " +
              res.data.person.passportNumber;
            this.person = res.data.person;
            this.SearchLoading = false;
            this.Searched = true;
          })
          .catch((error) => {
            this.SearchLoading = false;
            this.Searched = true;
            this.makeToast(error.response.data.errors, "error");
            this.Inspector = [];
            this.person = {};
            this.fio = "";
            this.passport = "";
          });
      }
    },
    toggle() {
      this.sidebar1 = !this.sidebar1;
      this.password = {
        oldpassword: "",
        newpassword: "",
        confirmedpassword: "",
      };
    },
    changepassword() {
      this.passwordLoading = true;
      AccountService.ChangePassword(this.password)
        .then((res) => {
          this.passwordLoading = false;
          this.makeToast(this.$t("PasswordChangedSuccess"), "success");
        })
        .catch((error) => {
          this.passwordLoading = false;
          this.makeToast(error.response.data.error, "error");
        });
    },
    ChangeStreetHouse() {
      if (!!this.Parent.livestreethousename) {
        this.Parent.ismultistoreyhouse = this.StreetHouseList.filter(
          (item) => item.streethousename === this.Parent.livestreethousename
        )[0].ismultistoreyhouse;
      }
    },
    makeToast(message, type) {
      var a = "";
      if (message.status == 500) {
        a = message.title;
      }
      if (message.status == 400) {
        var errors = Object.values(message.errors);
        var a = errors.map((el, item) => item + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.inspector-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgba(63, 117, 254, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(63, 117, 254, 0.12);
  }

  &__body {
    flex: 1 1 auto;
  }

  &__footer {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px dashed #e5e7eb;
  }
}

.inspector-row {
  margin-bottom: 10px;
  line-height: 1.45;
  word-break: break-word;

  &:last-child {
    margin-bottom: 0;
  }
}

.no-right-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: #FEF2F2;
  color: #DC2626;
  border: 1px solid #FECACA;
  border-radius: 12px;
  font-weight: 600;
  font-size: 15px;
}

.inspection-right-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #E8F8EE;
  color: #16A34A;
  font-weight: 600;
  font-size: 14px;
  border-radius: 999px;
}
</style>
